import {
  ConversationAttributesModel,
  ConversationItem,
  ConversationReferenceTypeEnum,
  MessageAttachmentItem,
  MessageItem,
  PublicListConversationsParams,
  PublicUserDataModel,
  SendMessageFromPublicPayload
} from '@appTypes/chat-api.types';
import { ChatAttachmentUploadItem, ChatOpenConversationParams, ChatSendMessageByReferencePayload } from '../chat.type';

export class chatInit {
  static readonly type = '[Chat] Init chat';
  constructor(
    public socketId: string,
    public user: PublicUserDataModel
  ) {}
}
export class chatReset {
  static readonly type = '[Chat] Reset';
}
export class chatOpenConversation {
  static readonly type = '[Chat] Open Conversation';
  constructor(public payload: ChatOpenConversationParams) {}
}
export class chatLoadChatBox {
  static readonly type = '[Chat] Load Chat Box';
  constructor(public payload: ChatOpenConversationParams) {}
}
export class chatLoadChatBoxes {
  static readonly type = '[Chat] Load Chat Boxes';
  constructor(public payload: PublicListConversationsParams) {}
}
export class chatLoadConversationsList {
  static readonly type = '[Chat] Load Conversations List';
}
export class chatResetConversationsList {
  static readonly type = '[Chat] Reset Conversations List';
}
export class chatLoadMessagesList {
  static readonly type = '[Chat] Load Messages List';
  constructor(public payload: { conversationId: string }) {}
}
export class chatUpsertMessages {
  static readonly type = '[Chat] Upsert Messages';
  constructor(public payload: MessageItem[]) {}
}
export class chatUpdateConversation {
  static readonly type = '[Chat] Update Conversation';
  constructor(public payload: ConversationItem[]) {}
}

export class chatSendMessage {
  static readonly type = '[Chat] Send Message';
  constructor(
    public conversationId: string,
    public messageId: string
  ) {}
}

export class chatSendMessageByReference {
  static readonly type = '[Chat] Send Message By Reference';
  constructor(public payload: ChatSendMessageByReferencePayload) {}
}

export class chatCreateMessage {
  static readonly type = '[Chat] Create Message';
  constructor(
    public conversationId: string,
    public payload: Omit<SendMessageFromPublicPayload, 'senderTimestamp'>,
    public attachmentsToUpload?: ChatAttachmentUploadItem[]
  ) {}
}

export class chatUploadMessageAttachments {
  static readonly type = '[Chat] Upload Message Attachments';
  constructor(public payload: { conversationId: string; messageId: string }) {}
}

export class chatCreateDraftConversation {
  static readonly type = '[Chat] Create Draft Conversation';
  constructor(
    public payload: {
      reference: ConversationReferenceTypeEnum;
      referenceId: string;
      attributes?: ConversationAttributesModel;
    }
  ) {}
}

export class chatCreateConversation {
  static readonly type = '[Chat] Create Conversation';
  constructor(
    public draftChatboxId: string,
    public draftMessageId?: string
  ) {}
}
export class chatDownloadAttachment {
  static readonly type = '[Chat] Download Attachment';
  constructor(public payload: { attachment: MessageAttachmentItem; conversationId: string; messageId: string }) {}
}

export class chatOpenConversationsList {
  static readonly type = '[Chat] Open Conversations List';
}
export class chatGetUnseenMessagesCount {
  static readonly type = '[Chat] Get Unseen Messages Count';
  constructor(public payload?: { initialLoad: boolean }) {}
}
export class chatConversationMarkAsSeen {
  static readonly type = '[Chat] Mark as seen for conversation';
  constructor(public payload: { conversationId: string }) {}
}
